import { useState, useEffect, useCallback, useMemo } from 'react';

const useScheduleData = (scheduleType) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Carga bajo demanda cuando cambia el tipo
  useEffect(() => {
    if (!scheduleType) {
      setData([]);
      return;
    }

    setLoading(true);

    const loadData = async () => {
      try {
        // Import dinámico - Webpack lo maneja
        const modules = {
          'EPF': () => import('../data/horariosEPF.json'),
          'EPM': () => import('../data/horariosEPM.json'),
          'EPA': () => import('../data/horariosEPA.json'),
          'EPIQ': () => import('../data/horariosEPIQ.json'),
          'EPIEL': () => import('../data/horariosEPIEL.json'),
          'EPIEN': () => import('../data/horariosEPIEN.json'),
          'EPIME': () => import('../data/horariosEPIME.json'),
          'EPII': () => import('../data/horariosEPII.json'),
          'EPC': () => import('../data/horariosEPC.json'),
          'EPEF': () => import('../data/horariosEPEF.json'),
          'EPIAM': () => import('../data/horariosEPIAM.json'),
          'EPE': () => import('../data/horariosEPE.json'),
          'EPIS': () => import('../data/horariosEPIS.json'),
        };

        const importFn = modules[scheduleType];
        if (importFn) {
          const json = await importFn();
          setData(json.default || json);
        }
      } catch (err) {
        console.error('Error:', err);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [scheduleType]);

  const filterCourses = useCallback((searchTerm) => {
    if (!searchTerm || searchTerm.length < 3) return data;
    const term = searchTerm.toLowerCase();
    return data.filter(c =>
      c.Curso.toLowerCase().includes(term) ||
      c.Codigo.toLowerCase().includes(term)
    );
  }, [data]);

  const uniqueCourses = useMemo(() => {
    const seen = new Set();
    return data.filter(c => {
      const key = `${c.Codigo}-${c.Seccion}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }, [data]);

  return { data, loading, filteredCourses: filterCourses, uniqueCourses, count: data.length };
};

export default useScheduleData;